import React, { FC } from "react";
import type { PlatformGlobalSingleSharedPlatformProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Image } from "../image";

export const PlatformGlobalSingleSharedPlatform: FC<
  PlatformGlobalSingleSharedPlatformProps
> = ({ title, description, image }) => {
  return (
    <section className="platformGlobalSingleSharedPlatform">
      <div className="platformGlobalSingleSharedPlatform--inner">
        <div className="platformGlobalSingleSharedPlatform--content">
          <div className="platformGlobalSingleSharedPlatform--text">
            {title && (
              <ContentManager
                content={title}
                className="platformGlobalSingleSharedPlatform--title"
              />
            )}
            {description && (
              <ContentManager
                content={description}
                className="platformGlobalSingleSharedPlatform--description"
              />
            )}
          </div>
          <div className="platformGlobalSingleSharedPlatform--image-wrapper">
            {image?.file?.url && (
              <Image
                className="platformGlobalSingleSharedPlatform--image"
                src={image as any}
                alt={image.title}
                options={{
                  sizes: {
                    exec: [
                      {
                        width: 704,
                        height: 663,
                      },
                    ],
                  },
                }}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
